// Audio and haptic feedback utilities for QR scanner
// Created for modular feedback system

// Audio feedback functions using HTML5 Audio API
export const createAudioElement = (src: string, volume: number): HTMLAudioElement | null => {
  if (typeof window === 'undefined') return null;

  try {
    const audio = new Audio(src);
    audio.volume = volume;
    audio.preload = 'auto';
    return audio;
  } catch (error) {
    console.warn(`Failed to create audio element for ${src}:`, error);
    return null;
  }
};

export const playAudio = (audio: HTMLAudioElement | null, soundType: string) => {
  if (!audio) return;

  try {
    audio.currentTime = 0; // Reset to start
    audio.play().catch((error) => {
      console.warn(`Failed to play ${soundType} sound:`, error);
    });
  } catch (error) {
    console.warn(`Error playing ${soundType} sound:`, error);
  }
};

// Haptic feedback functions
export const triggerVibration = (pattern: number | number[]) => {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(pattern);
      // console.log('Haptic feedback triggered:', pattern)
    } catch (error) {
      console.warn('Haptic feedback failed:', error);
    }
  } else {
    // console.log('Haptic feedback not supported')
  }
};

export const hapticFeedback = {
  qrDetected: () => triggerVibration(100), // Only for QR detection
};

// Audio file paths configuration (only success and error sounds)
export const AUDIO_PATHS = {
  success: '/sounds/qr-success.wav',
  error: '/sounds/qr-error.wav',
  duplicate: '/sounds/qr-duplicate.wav',
} as const;

// Volume levels configuration
export const AUDIO_VOLUMES = {
  success: 1,
  error: 1,
  duplicate: 1,
} as const;
